import { Component, OnInit } from '@angular/core';
import {SimpleModalComponent} from "ngx-simple-modal";
import {AddExamSubjectModal} from "../add-exam-subject-modal/add-exam-subject-modal.component";
import {ReadableStudentChangeResponse, StudentsClient} from "../../../generated-client/generated-api-client";

export interface StudentChangesModal {
  studentId?: string;
}

@Component({
  selector: 'app-student-changes-modal',
  templateUrl: './student-changes-modal.component.html',
  styleUrls: ['./student-changes-modal.component.sass']
})
export class StudentChangesModalComponent
  extends SimpleModalComponent<StudentChangesModal, boolean>
  implements StudentChangesModal {

  studentId?: string;
  changes?: ReadableStudentChangeResponse[];
  isLoading = true;

  constructor(private studentsClient: StudentsClient) {
    super();
  }


  ngOnInit(): void {
    this.studentsClient.getReadableStudentChanges(this.studentId ?? '').subscribe(response => {
      this.changes = response;
      this.isLoading = false;
    });
  }

}
